import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Ellenőrizzük, hogy valódi Supabase konfiguráció van-e
// Bugfix: Check for nullability before calling string methods
const isPlaceholder = !supabaseUrl || 
                      !supabaseKey || 
                      (typeof supabaseUrl === 'string' && supabaseUrl.includes('placeholder')) || 
                      (typeof supabaseKey === 'string' && supabaseKey.includes('placeholder'));

if (isPlaceholder) {
  console.warn('⚠️ Placeholder Supabase konfiguráció. Az admin funkciók nem fognak működni.');
}

// Alapértelmezett dummy értékek, hogy ne dobjon hibát
const finalUrl = supabaseUrl || 'https://placeholder.supabase.co';
const finalKey = supabaseKey || 'placeholder-key';

export const supabase = createClient(finalUrl, finalKey);
export const isSupabaseConfigured = !isPlaceholder;

